import { CardStyle } from "./style";

export const CardComponent = props => (
    <CardStyle {...props}>
        {props.children}
    </CardStyle>
)